module.exports = __webpack_public_path__ + "img/cover-vagues.d7ad96d8.jpg";